import { SetterOrUpdater, useRecoilValue } from "recoil";
import GridTemplate from "../../../../components/GridTemplate";
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Card,
    CardActions,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Fab,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Paper,
    Select,
    SelectChangeEvent,
    Skeleton,
    styled,
    TextField,
    Typography,
} from "@mui/material";

import {
    AbcOutlined,
    AddOutlined,
    BookmarkAddedOutlined,
    CheckCircleRounded,
    CloseOutlined,
    DoNotDisturbOnRounded,
    DownloadOutlined,
    DriveFileRenameOutlineOutlined,
    FilePresentOutlined,
    FullscreenOutlined,
    HandshakeOutlined,
    HideImageOutlined,
    KeyOutlined,
    QuestionAnswerOutlined,
    RemoveCircleOutlineOutlined,
    SaveOutlined,
    WhatsApp,
} from "@mui/icons-material";

import { GridColDef } from "@mui/x-data-grid";
import { ContentProps, Toast } from "primereact/toast";
import { userAtom } from "../../../../atoms/atoms";

import {
    SyntheticEvent,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";

import { TreeItem, treeItemClasses } from "@mui/x-tree-view";

import Rmodal from "../../../../components/Rmodal";
import { Fieldset } from "primereact/fieldset";

import { DepartmentSimpleType, SecretarySimpleType, SelectedParametersType, UserType } from "../../../../types/types";

import {
    getFilteredList,
    setToastRefToOpen,
} from "../../../../functions/functions";

import ticketsfindAllByCustomerAndActivated from "../../../../resources/Api/tickets/ticketsfindAllByCustomerAndActivated";
import ticketsfindAllByActivated from "../../../../resources/Api/tickets/ticketsfindAllByActivated";
import ticketTypesFindAllByActivated from "../../../../resources/Api/tickets/ticketTypesFindAllByActivated";
import ticketGravitiesFindAllByActivated from "../../../../resources/Api/tickets/ticketGravitiesFindAllByActivated";
import ticketSaveByDepartment from "../../../../resources/Api/tickets/ticketSaveByDepartment";
import ticketUpdateById from "../../../../resources/Api/tickets/ticketUpdateById";
import ticketUpdateStatusById from "../../../../resources/Api/tickets/ticketUpdateStatusById";
import ticketSaveJustification from "../../../../resources/Api/tickets/ticketSaveJustification";
import helpTicketFindAllExportResponse from "../../../../resources/Api/tickets/helpTicketFindAllExportResponse";
import { departmentDefault, secretaryDefault } from "../../../../consts/consts";
import userFindAllSecretariesListResponse from "../../../../resources/Api/user/userFindAllSecretariesListResponse";
import userFindAllDepartmentsListResponse from "../../../../resources/Api/user/userFindAllDepartmentsListResponse";
import { oldTotalTicketsUnresolvedLocalStorageKey } from "../../../../consts/consts";
import { isImpersonationLocked } from "../../../../utils/impersonation";

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={<KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <DoNotDisturbOnRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    {
        field: "reslved",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Resolviddo"}
                icon={
                    <HandshakeOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <div style={{ background: "transparent", fontFamily: "Prometo" }}>
                {item.row.resolved ? (
                    <Chip
                        label={
                            <Typography className="activated" fontSize={"14px"}>
                                Sim
                            </Typography>
                        }
                    />
                ) : (
                    <Chip
                        label={
                            <Typography className="deactivated" fontSize={"14px"}>
                                Não
                            </Typography>
                        }
                    />
                )}
            </div>
        ),
    },
    {
        field: "departmentSecretaryCustomerReducedName",
        align: "left",
        width: 250,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Cliente"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.departmentSecretaryCustomerReducedName ?? ""}
            />
        ),
    },
    {
        field: "departmentSecretaryReducedName",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Secretaria"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.departmentSecretaryReducedName}
            />
        ),
    },
    {
        field: "departmentReducedName",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Departamento"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.departmentReducedName}
            />
        ),
    },
    {
        field: "type",
        align: "left",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Tipo"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.typeName || "Geral"}
            />
        ),
    },
    {
        field: "gravity",
        align: "left",
        width: 150,
        headerClassName: "last-column",
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Gravidade"}
                icon={<AbcOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.gravityName || "Geral"}
            />
        ),
    },
];

const rowsOptions = (
    list: Array<any>,
    openDetails?: SetterOrUpdater<boolean>
): Array<any> => {
    const result = [...list];
    return result.map((item) => ({ ...item, openDetails }));
};

const CustomerHelpDeskComponent = () => {
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    // functionalities states
    const [isOnline, setIsOnline] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<"warn" | "success" | "info" | "error" | undefined>("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [inEdit, setInEdit] = useState<boolean>(false);
    const [inInsert, setInInsert] = useState<boolean>(false);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<any>>([]);

    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    const [isOpenAnswer, setIsOpenAnswer] = useState<boolean>(false);
    const [isOpenJustification, setIsOpenJustification] = useState<boolean>(false);
    const [ticketJustifification, setTicketJustification] = useState<string>("");

    const [ticketDescription, setTicketDescription] = useState<string>("");
    const [ticketType, setTicketType] = useState<string>("");
    const [ticketGravity, setTicketGravity] = useState<string>("");
    const [ticketRemovedFiles, setTicketRemovedFiles] = useState<Array<number>>([]);
    const [ticketFiles, setTicketFiles] = useState<Array<string | null | undefined | File | any>>([]);
    const [currentTicketFile, setCurrentTicketFile] = useState<string | null | undefined | File | any>(null);

    const [ticketTypesList, setTicketTypesList] = useState<Array<any>>([]);
    const [ticketGravitiesList, setTicketGravitiesList] = useState<Array<any>>([]);
    const [ticketsList, setTicketsList] = useState<Array<any>>([]);

    const [selectedTicket, setSelectedTicked] = useState<any>({
        id: -1,
        activated: true,
    });

    const [secretariesList, setSecretariesList] = useState<Array<SecretarySimpleType>>([]);
    const [departmentsList, setDepartmentsList] = useState<Array<DepartmentSimpleType>>([]);

    const [secretary, setSecretary] = useState<SecretarySimpleType>(secretaryDefault);
    const [department, setDepartment] = useState<DepartmentSimpleType>(departmentDefault);

    // refs
    const fileInputRef = useRef<HTMLInputElement>(null);
    const toastModalRef = useRef<Toast>(null);
    const toastRef = useRef<Toast>(null);

    // cookies
    const [cookies, _] = useCookies(["selectedParameters", "token"]);
    const location = useLocation();

    const currentParameters: SelectedParametersType = useMemo(
        () => cookies.selectedParameters,
        [cookies.selectedParameters]
    );

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setTextValidation("");
        setIsOpenDetails(false);
        setSelectedTicked({
            id: -1,
            activated: true,
        });
        setInEdit(false);
        setInInsert(false);
        setTicketDescription("");
        setTicketType("");
        setTicketGravity("");
        setTicketFiles([]);
        setCurrentTicketFile(null);
        setTicketRemovedFiles([]);
    }, []);

    const addItens = useCallback(() => {
        if (currentTicketFile) {
            const reader = new FileReader();
            reader.readAsDataURL(currentTicketFile[0]);
            reader.onloadend = () => {
                setTicketFiles((prev) => [
                    ...prev,
                    {
                        file: reader.result as string,
                        type: currentTicketFile[0].type.substring(0, 5),
                        id: Math.random(),
                    },
                ]);
            };
        } else {
            setCurrentTicketFile("");
        }
    }, [currentTicketFile]);

    useEffect(() => {
        addItens();
    }, [addItens]);

    useEffect(() => {
        const ref = isOpenDetails ? toastModalRef : toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);

    const getSecretariesList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;
        try {
            const response = await userFindAllSecretariesListResponse(
                token,
                userId
            );
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, getCurrentUser.id]);

    useEffect(() => {
        if (currentParameters?.isViewingAll) {
            getSecretariesList();
        }
    }, [getSecretariesList, currentParameters?.isViewingAll]);

    const getDepartmentsList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const userId = getCurrentUser.id;

        try {
            const response =
                await userFindAllDepartmentsListResponse(
                    token,
                    userId,
                    secretary?.id
                );
            setDepartmentsList(response.data);
        } catch (error) {
            console.log(error);
            setDepartmentsList([]);
        }
    }, [cookies.token, getCurrentUser.id, secretary.id]);

    useEffect(() => {
        if (secretary?.name) {
            getDepartmentsList();
        }
    }, [getDepartmentsList, secretary?.name]);

    const getAllTicketTypesList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        try {
            const { data } = await ticketTypesFindAllByActivated(token, "activated");
            if (data.length > 0) {
                setTicketTypesList(data);
            }
        } catch (error: any) {
            console.log(error);
            setTicketTypesList([]);
        }
    }, [cookies.token]);

    const getAllTicketGravitiesList = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        try {
            const { data } = await ticketGravitiesFindAllByActivated(
                token,
                "activated"
            );
            if (data.length > 0) {
                setTicketGravitiesList(data);
            }
        } catch (error: any) {
            console.log(error);
            setTicketGravitiesList([]);
        }
    }, [cookies.token]);

    const getAllTicketsByCustomer = useCallback(
        async (status: string = "activated", page: number = 0, size: number = 100) => {
            const token: string = cookies.token || sessionStorage.getItem("token");

            setLoading(true);
            try {
                const { data } = await ticketsfindAllByCustomerAndActivated(
                    token,
                    currentParameters?.customer.managerId!!,
                    currentParameters?.customer.id,
                    currentParameters?.department.id,
                    status,
                    page,
                    size,
                    currentParameters?.isViewingAll
                );
                setTicketsList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements);
                setPageNumber(data.pageable.pageNumber);
                if (data.first) {
                    setNumberOfElements(data.totalElements);
                    // localStorage.setItem(`${oldTotalTicketsUnresolvedLocalStorageKey}_${getCurrentUser.id}`, data.totalElements.toString());
                }
            } catch (error: any) {
                console.log(error);
                setTicketsList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [cookies.token, currentParameters?.customer.managerId, currentParameters?.customer.id, currentParameters?.department.id, currentParameters?.isViewingAll]
    );

    const getAllTickets = useCallback(
        async (status: string = "activated", page: number = 0, size: number = 100) => {
            const token: string = cookies.token || sessionStorage.getItem("token");

            setLoading(true);
            try {
                const { data } = await ticketsfindAllByActivated(token, currentParameters?.customer.id, status, page, size);
                setTicketsList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements);
                setPageNumber(data.pageable.pageNumber);

                if (data.first) {
                    setNumberOfElements(data.totalElements);
                    localStorage.setItem(`${oldTotalTicketsUnresolvedLocalStorageKey}_${getCurrentUser.id}`, data.totalElements.toString());
                }
            } catch (error: any) {
                console.log(error);
                setTicketsList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [cookies.token, currentParameters?.customer.id, getCurrentUser.id]
    );

    const handleGetAllTickets = useCallback((activated: string, page: number, size: number) => {
        if (getCurrentUser.configs.isManager) {
            getAllTickets(activated, page, size);
        } else {
            getAllTicketsByCustomer(activated, page, size);
        }
    }, [getCurrentUser.configs.isManager, getAllTickets, getAllTicketsByCustomer]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager) {
            getAllTickets();
        } else {
            getAllTicketsByCustomer();
        }
        getAllTicketGravitiesList();
        getAllTicketTypesList();
    }, [
        getAllTickets,
        getAllTicketsByCustomer,
        getAllTicketGravitiesList,
        getAllTicketTypesList,
        getCurrentUser.configs.isManager,
    ]);

    const getReport = useCallback(
        async (type: string) => {
            setLoading(true);
            let dataBuffer = new ArrayBuffer(0);
            const departmentId = (currentParameters?.department?.id !== -1) ? currentParameters?.department?.id : -1;
            const customerId = currentParameters?.customer.id ?? -1;

            let reportType = type;
            let isSimpleType = false;
            if (type.includes("simple")) {
                reportType = reportType.split(" ")[0];
                isSimpleType = true;
            };
            // simpleXlsxExport = false

            try {
                const { data }: any =
                    await helpTicketFindAllExportResponse(cookies.token,
                        ticketsList.length > 0 && ticketsList[0].activated
                            ? "activated"
                            : "deactivated",
                        reportType, customerId, departmentId, currentParameters?.isViewingAll, isSimpleType);

                if ((data as ArrayBuffer).byteLength === 0) {
                    setTextValidation("Nenhum dado para mostrar no relatório.");
                    setStatusMessage("warn");
                    setFieldsIsValid(false);
                } else {
                    setTextValidation("Relatório gerado com sucesso.");
                    setStatusMessage("success");
                    setFieldsIsValid(false);
                    dataBuffer = data;
                }
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    setReport(dataBuffer);
                    setExportType(type);
                }, 3000);
            }
        },
        [cookies.token, ticketsList, currentParameters?.customer.id, currentParameters?.department?.id, currentParameters?.isViewingAll, handleClose]
    );

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport =
                exportType === "pdf"
                    ? "application/pdf"
                    : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    const loadingEsqueleton = useMemo(() => {
        return (
            <Grid
                className="container "
                sx={{
                    height: 650,
                    width: 950,
                }}
            >
                {Array.from(new Array(1)).map((_, i) => (
                    <Box key={i} sx={{ width: "100%", height: 650, padding: 5 }}>
                        <Skeleton height={56} />
                        <Skeleton height={56} />
                        <Skeleton height={56} />
                        <Skeleton variant="rectangular" width={"100%"} height={350} />
                    </Box>
                ))}
            </Grid>
        );
    }, []);

    const CustomTreeItem = styled(TreeItem)({
        [`& .${treeItemClasses.iconContainer}`]: {
            "& .close": {
                opacity: 0.3,
            },
        },
    });

    useEffect(() => {
        setFilteredList(
            getFilteredList(
                ["departmentSecretaryCustomerReducedName", "departmentReducedName", "typeName", "gravityName"],
                ticketsList,
                query
            )
        );
    }, [ticketsList, query]);

    const onSave = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        // const currentParameters: SelectedParametersType = cookies.selectedParameters;
        const departmentId = currentParameters?.isViewingAll ? department.id : currentParameters.department.id;
        const customerName = currentParameters.customer?.reducedName ?? currentParameters.customer.name;

        setLoading(true);

        type TicketRquestType = {
            id: number;
            name: string;
            description: string;
            typeId: number;
            gravityId: number;
            files: Array<any>;
            removedFiles: Array<any>;
            departmentId: number;
            customerReducedName: string;
        };

        const data: TicketRquestType = {
            id: -1,
            name: getCurrentUser.name,
            description: ticketDescription,
            typeId: ticketTypesList.find((item) => item.name === ticketType)?.id!!,
            gravityId: ticketGravitiesList.find((item) => item.name === ticketGravity)
                ?.id!!,
            files: ticketFiles.map((it) => it.file),
            removedFiles: [],
            departmentId: departmentId,
            customerReducedName: customerName
        };

        if (!data.description || !data.typeId || !data.gravityId) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await ticketSaveByDepartment(token, data);
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllTickets();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        getAllTickets,
        ticketGravity,
        ticketType,
        department.id,
        getCurrentUser.name,
        ticketDescription,
        ticketTypesList,
        ticketGravitiesList,
        ticketFiles,
        currentParameters?.department.id,
        currentParameters?.isViewingAll,
        cookies.token,
        handleClose,
        currentParameters.customer?.reducedName,
        currentParameters.customer?.name
    ]);

    const onUpdate = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        setLoading(true);

        type TicketRquestType = {
            id: number;
            name: string;
            description: string;
            typeId: number;
            gravityId: number;
            files: Array<any>;
            removedFiles: Array<any>;
            departmentId: number;
            customerReducedName: string;
        };

        const data: TicketRquestType = {
            id: selectedTicket.id!!,
            name: selectedTicket.name,
            description: ticketDescription,
            typeId: ticketTypesList.find((item) => item.name === ticketType)?.id!!,
            gravityId: ticketGravitiesList.find((item) => item.name === ticketGravity)
                ?.id!!,
            files: ticketFiles
                .filter(
                    (it) => !selectedTicket.files.map((a: any) => a.id).includes(it.id)
                )
                .map((it) => it.file),
            removedFiles: ticketRemovedFiles,
            departmentId: selectedTicket.departmentId,
            customerReducedName: selectedTicket.departmentSecretaryCustomerReducedName
        };

        if (!data.description || !data.typeId || !data.gravityId) {
            setTextValidation(
                "Todos os campos são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        if (
            data.description === selectedTicket.description &&
            data.typeId === selectedTicket.typeId &&
            data.gravityId === selectedTicket.gravityId &&
            data.files.length === selectedTicket.files.length &&
            data.removedFiles.length === 0
        ) {
            setTextValidation("Nada foi alterado.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await ticketUpdateById(token, data, data.id);
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllTickets();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        getAllTickets,
        ticketRemovedFiles,
        ticketGravity,
        ticketType,
        ticketDescription,
        ticketTypesList,
        ticketGravitiesList,
        selectedTicket,
        ticketFiles,
        cookies.token,
        handleClose,
    ]);

    const onUpdateStatus = useCallback(
        async (id: number, status: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            setLoading(true);
            try {
                await ticketUpdateStatusById(token, id, status);
                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    currentParameters?.customer.id
                        ? getAllTicketsByCustomer()
                        : getAllTickets();
                }, 8000);
            }
        },
        [
            cookies.token,
            currentParameters?.customer.id,
            getAllTicketsByCustomer,
            getAllTickets,
            handleClose,
        ]
    );

    const onUpdateJustification = useCallback(
        async (id: number) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            setLoading(true);

            type TicketJustifyRequestType = {
                id: number;
                description: string;
                userId: number;
            };

            const data: TicketJustifyRequestType = {
                id: -1,
                description: ticketJustifification,
                userId: getCurrentUser.id,
            };

            if (!data.description) {
                setTextValidation("O campo justificativa é obrigatório.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
                setLoading(false);
                return;
            }

            try {
                await ticketSaveJustification(token, id, data);

                setIsOpenJustification(false);
                setTicketJustification("");

                setLoading(false);
                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
            } catch (error: any) {
                const { data } = error.response;

                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            } finally {
                setTimeout(() => {
                    handleClose();
                    getAllTickets();
                }, 3000);
            }
        },
        [
            cookies.token,
            getCurrentUser?.id,
            ticketJustifification,
            handleClose,
            getAllTickets,
        ]
    );

    const handleOnEditValues = useCallback(
        (selectedTicket: any) => {
            if (selectedTicket?.id !== -1 && !inInsert) {
                setTicketDescription(selectedTicket.description);
                setTicketType(selectedTicket.typeName);
                setTicketGravity(selectedTicket.gravityName);
                setTicketFiles([
                    ...selectedTicket.files.map((it: any) => ({
                        file: it.file as string,
                        type: it.file.substring(5, 10),
                        id: it.id,
                    })),
                ]);
            }
        },
        [inInsert]
    );

    const verifyBeforeUpdateStatus = useCallback(
        (id: number, status: string) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente atualizar o status desse registro?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onUpdateStatus(id, status);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onUpdateStatus, isToastVisible, statusMessage]
    );

    const verifyBeforeCancel = useCallback(
        (selected: any) => {
            const ref = toastModalRef;
            let canCancel = true;

            if (inEdit && !inInsert) {
                if (
                    selected.description !== ticketDescription ||
                    selected.typeName !== ticketType ||
                    selected.gravityName !== ticketGravity ||
                    selected.files.length !== ticketFiles.length ||
                    ticketRemovedFiles.length !== 0
                ) {
                    canCancel = false;
                }
            } else if (
                !inEdit &&
                inInsert &&
                (ticketDescription ||
                    ticketType ||
                    ticketGravity ||
                    ticketFiles.length > 0)
            ) {
                canCancel = false;
            }

            if (!canCancel) {
                if (!isToastVisible) {
                    setToastRefToOpen(
                        ref,
                        "Existem dados não salvos, deseja realmente cancelar?",
                        "Atenção!",
                        statusMessage,
                        {
                            content: (props: ContentProps) => (
                                <Box
                                    className="flex flex-column align-items-left"
                                    style={{ flex: "1" }}
                                >
                                    <Typography>{props?.message.summary}</Typography>
                                    <Box className="font-medium text-lg my-3 text-900">
                                        {props?.message.detail}
                                    </Box>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            handleClose();
                                        }}
                                    >
                                        Sim
                                    </Button>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            setIsToastVisible(false);
                                        }}
                                    >
                                        Não
                                    </Button>
                                </Box>
                            ),
                        },
                        undefined,
                        true
                    );
                    setIsToastVisible(true);
                }
            } else {
                handleClose();
            }
        },
        [
            inEdit,
            inInsert,
            handleClose,
            statusMessage,
            isToastVisible,
            ticketDescription,
            ticketRemovedFiles.length,
            ticketType,
            ticketGravity,
            ticketFiles,
        ]
    );

    const justificationAnswer = useMemo(() => {
        return (
            <>
                <Dialog
                    open={isOpenAnswer}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <Box sx={{ background: "#f3f4f6" }}>
                        <DialogTitle id="responsive-dialog-title">
                            {`Olá, ${selectedTicket.name}`}
                        </DialogTitle>

                        <Paper sx={{ boxShadow: "None", padding: 2 }}>
                            <DialogContent>
                                <DialogContentText>
                                    {selectedTicket?.justification}
                                </DialogContentText>
                            </DialogContent>
                        </Paper>

                        <DialogActions>
                            <Box
                                className="tw-flex tw-w-full tw-justify-end"
                                sx={{ display: "flex", width: "100%", justifyContent: "flex-end", paddingTop: 2 }}
                            >
                                <Paper
                                    className="tw-flex tw-w-full tw-justify-end sm:tw-w-auto"
                                    elevation={0}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        width: { xs: "100%", sm: "auto" },
                                        marginLeft: "auto",
                                        background: "transparent",
                                    }}
                                >
                                    <Button
                                        type="button"
                                        style={{
                                            fontFamily: "Prometo",
                                            color: "#ffff",
                                            marginRight: 5,
                                        }}
                                        disabled={false}
                                        onClick={() => {
                                            if (!isToastVisible) {
                                                setIsOpenAnswer(false);
                                            }
                                        }}
                                        className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                    >
                                        <CloseOutlined style={{ marginRight: 5 }} />
                                        <Typography
                                            className="forgot-password"
                                            style={{
                                                fontFamily: "Prometo",
                                                fontSize: "16px",
                                                color: "#ffff",
                                            }}
                                        >
                                            Fechar
                                        </Typography>
                                    </Button>
                                </Paper>
                            </Box>
                        </DialogActions>
                    </Box>
                </Dialog>
            </>
        );
    }, [
        selectedTicket?.justification,
        isOpenAnswer,
        handleClose,
        isToastVisible,
        selectedTicket.name,
    ]);

    const justificationModal = useMemo(
        () => (
            <>
                <Dialog
                    open={isOpenJustification}
                    onClose={() => { }}
                    hideBackdrop={false}
                    style={{ zIndex: 99999 }}
                >
                    <Box
                        className="container container-fluid"
                        style={{ padding: 20, height: 250, width: 500 }}
                    >
                        <FormControl
                            className="form-group"
                            style={{ display: "flex", width: "100%", marginBottom: 5 }}
                        >
                            <InputLabel
                                id="demo-multiple-password-label"
                                shrink
                                disabled={false}
                                style={{ fontFamily: "Prometo" }}
                            >
                                Justificativa
                            </InputLabel>
                            <TextField
                                name="name"
                                autoComplete="off"
                                multiline
                                rows={5}
                                InputProps={{
                                    label: "Justificativa",
                                    notched: true,
                                    style: { fontFamily: "Prometo" },
                                }}
                                disabled={false}
                                value={ticketJustifification}
                                onChange={(event) => {
                                    setTicketJustification(event.target.value);
                                }}
                                type="text"
                                className="form-control-login"
                                placeholder="Digite a justificativa"
                            />
                            <IconButton
                                aria-label="toggle password visibility"
                                className="visibility-password"
                                disabled
                                onMouseDown={(e: SyntheticEvent) => { }}
                                edge="end"
                                size="large"
                            >
                                <AbcOutlined />
                            </IconButton>
                        </FormControl>
                        <Alert
                            style={{
                                borderRadius: 5,
                                padding: 10,
                                marginBottom: 20,
                            }}
                            severity="info"
                        >
                            {
                                "Digite a resolução do problema, adicione data da resolução, pessoa responsável informada e data de atualização do sistema em caso de ajustes."
                            }
                        </Alert>
                    </Box>
                    <DialogActions>
                        <Box
                            className="tw-flex tw-w-full tw-justify-end"
                            sx={{ display: "flex", width: "100%", justifyContent: "flex-end", paddingTop: 2 }}
                        >
                            <Paper
                                className="tw-flex tw-w-full tw-flex-col-reverse tw-gap-2 sm:tw-w-auto sm:tw-flex-row"
                                elevation={0}
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column-reverse", sm: "row" },
                                    justifyContent: "flex-end",
                                    width: { xs: "100%", sm: "auto" },
                                    marginLeft: "auto",
                                    gap: 1,
                                    background: "transparent",
                                }}
                            >
                                <Button
                                    type="button"
                                    style={{
                                        fontFamily: "Prometo",
                                        color: "#ffff",
                                        marginRight: 5,
                                    }}
                                    disabled={false}
                                    onClick={() => {
                                        if (!isToastVisible) {
                                            setIsOpenJustification(false);
                                            setTicketJustification("");
                                        }
                                    }}
                                    className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                >
                                    <CloseOutlined style={{ marginRight: 5 }} />
                                    <Typography
                                        className="forgot-password"
                                        style={{
                                            fontFamily: "Prometo",
                                            fontSize: "16px",
                                            color: "#ffff",
                                        }}
                                    >
                                        Cancelar
                                    </Typography>
                                </Button>
                                <Button
                                    type="button"
                                    style={{ fontFamily: "Prometo", color: "#ffff" }}
                                    onClick={() => {
                                        onUpdateJustification(selectedTicket.id);
                                    }}
                                    className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                >
                                    <SaveOutlined style={{ marginRight: 5 }} />
                                    <Typography
                                        className="forgot-password"
                                        style={{
                                            fontFamily: "Prometo",
                                            fontSize: "16px",
                                            color: "#ffff",
                                        }}
                                    >
                                        Salvar
                                    </Typography>
                                </Button>
                            </Paper>
                        </Box>
                    </DialogActions>
                </Dialog>
            </>
        ),
        [
            ticketJustifification,
            isOpenJustification,
            isToastVisible,
            selectedTicket.id,
            onUpdateJustification,
        ]
    );

    const onHandleFullScreen = (fileUrl: string, fileName: string) => {
        if (!document.fullscreenElement) {
            const element = document.createElement("img");
            element.className = "img-anexo";
            element.id = fileName;
            element.src = fileUrl;
            element.style.objectFit = "contain";
            document.body.appendChild(element);

            const img = document.querySelector(".img-anexo");
            img?.requestFullscreen().catch((err: any) => {
                console.error("Erro ao entrar em modo fullscreen:", err);
            });

            img?.addEventListener("fullscreenchange", () => {
                if (!document.fullscreenElement) {
                    document.body.removeChild(img);
                }
            });
        } else {
            document.exitFullscreen();
        }
    };

    const onHandleDownload = (fileUrl: string, fileName: string) => {
        const link = document.createElement("a");
        link.href = fileUrl;

        let extension = "";
        if (fileUrl.startsWith("data:")) {
            const mime = fileUrl.split(";")[0].split(":")[1];
            if (mime && mime.includes("/")) {
                extension = "." + mime.split("/")[1];
            }
        }
        
        link.download = fileName.includes(".") 
            ? fileName 
            : `${fileName || "download"}${extension || ".png"}`;
            
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const ticketLetter = useMemo(() => {
        const legendTemplate = (
            <Box className="flex" style={{ border: "none" }}>
                <Typography className="font-bold">{selectedTicket.name}</Typography>
            </Box>
        );

        return (
            <Box>
                <Box
                    className="col-md-12"
                    sx={{
                        margin: "15px 0px 15px 0px",
                        "& .p-fieldset-legend": { border: "none" },
                    }}
                >
                    <Fieldset
                        legend={legendTemplate}
                        style={{ height: 250, border: "1px solid gray" }}
                    >
                        <Typography>{selectedTicket.description}</Typography>
                    </Fieldset>
                </Box>

                <Box className="col-md-12" style={{ marginBottom: 20 }}>
                    {selectedTicket.resolved && <><Chip
                        style={{
                            color: "black",
                            marginRight: 5,
                            background: "#81c784",
                            fontWeight: "bolder",
                        }}
                        clickable={false}
                        onClick={() => { }}
                        label={`Respondido em: ${selectedTicket.respondedAt}`}
                    />
                        <Chip
                            style={{
                                color: "black",
                                marginRight: 5,
                                fontWeight: "bolder",
                            }}
                            clickable={false}
                            onClick={() => { }}
                            label={`Respondido por: ${selectedTicket.userResponded}`}
                        />
                    </>}
                </Box>

                <Box
                    className="col-sm-12 col-md-5"
                    style={{
                        display: "flex",
                        justifyContent: "start",
                        marginBottom: "20px",
                    }}
                >
                    <Chip
                        style={{
                            color: "black",
                            background: selectedTicket.gravityColor,
                            marginRight: 5,
                            width: "29%",
                        }}
                        disabled={false}
                        label={selectedTicket.gravityName}
                    />

                    <Chip
                        style={{
                            color: "black",
                            background: "#64b5f6",
                            marginRight: 5,
                            width: "29%",
                        }}
                        disabled={false}
                        label={selectedTicket.typeName}
                    />

                    <Chip
                        style={{
                            color: "black",
                            background: selectedTicket.activated ? "#81c784" : "#dc3545",
                            marginRight: 5,
                            width: "29%",
                            fontWeight: "bolder",
                        }}
                        clickable={false}
                        onClick={() => { }}
                        label={selectedTicket.activated ? "Ativo" : "Inativo"}
                    />

                    {selectedTicket.description && <Chip
                        style={{
                            color: "black",
                            marginRight: 5,
                            background: selectedTicket.resolved ? "#81c784" : "#dc3545",
                            fontWeight: "bolder",
                        }}
                        clickable={false}
                        onClick={() => { }}
                        label={`${selectedTicket.resolved ? "Solucionado" : "Pendente"}`}
                    />}
                </Box>

                <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                    <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                        Anexos
                    </Typography>
                </Box>

                <Box className="col-md-12" style={{ marginBottom: 20 }}>
                    <Box sx={{ paddingTop: 2, display: "flex" }}>
                        {ticketFiles && ticketFiles?.length > 0 ? (
                            ticketFiles?.map((item: any, index: any) => {
                                return (
                                    <>
                                        {item.type === "image" ? (
                                            <Card
                                                style={{
                                                    background: "#f3eeeec4",
                                                    padding: 5,
                                                    margin: 3,
                                                    borderRadius: 5,
                                                }}
                                            >
                                                <img
                                                    key={index}
                                                    src={item?.file}
                                                    alt={"preview"}
                                                    style={{
                                                        objectFit: "cover",
                                                        width: 150,
                                                        height: 150,
                                                        display: "flex",
                                                        boxShadow: "none",
                                                        borderRadius: 5,
                                                        background: "gray",
                                                        margin: 5,
                                                    }}
                                                />
                                                <CardActions
                                                    style={{ display: "flex", justifyContent: "center" }}
                                                >
                                                    <DownloadOutlined
                                                        onClick={() => onHandleDownload(item?.file, "anexo" + (index + 1))}
                                                        style={{
                                                            height: 24,
                                                            width: 24,
                                                            fill: "#00B700",
                                                            cursor: "pointer",
                                                        }}
                                                    />

                                                    <FullscreenOutlined
                                                        onClick={() => onHandleFullScreen(item?.file, "anexo" + (index + 1))}
                                                        style={{
                                                            height: 24,
                                                            width: 24,
                                                            fill: "blue",
                                                            cursor: "pointer",
                                                        }}
                                                    />
                                                </CardActions>
                                            </Card>
                                        ) : (
                                            <Card
                                                key={index}
                                                style={{
                                                    background: "#f3eeeec4",
                                                    padding: 5,
                                                    margin: 3,
                                                    borderRadius: 5,
                                                }}
                                            >
                                                <FilePresentOutlined
                                                    style={{
                                                        objectFit: "cover",
                                                        width: 150,
                                                        height: 150,
                                                        display: "flex",
                                                        boxShadow: "none",
                                                        borderRadius: 5,
                                                        background: "transparent",
                                                        fill: "#00b70080",
                                                        margin: 5,
                                                    }}
                                                />
                                                <CardActions
                                                    style={{ display: "flex", justifyContent: "center" }}
                                                >
                                                    <DownloadOutlined
                                                        onClick={() => onHandleDownload(item?.file, "anexo" + (index + 1))}
                                                        style={{
                                                            height: 24,
                                                            width: 24,
                                                            fill: "#00B700",
                                                            cursor: "pointer",
                                                        }}
                                                    />

                                                    <FullscreenOutlined
                                                        onClick={() => onHandleFullScreen(item?.file, "anexo" + (index + 1))}
                                                        style={{
                                                            height: 24,
                                                            width: 24,
                                                            fill: "red",
                                                            cursor: "pointer",
                                                        }}
                                                    />
                                                </CardActions>
                                            </Card>
                                        )}
                                    </>
                                );
                            })
                        ) : (
                            <Box>
                                <Typography>Nenhum anexo</Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        );
    }, [
        selectedTicket.name,
        selectedTicket.resolved,
        selectedTicket.respondedAt,
        selectedTicket.userResponded,
        selectedTicket.activated,
        selectedTicket.typeName,
        selectedTicket.gravityName,
        selectedTicket.description,
        selectedTicket.gravityColor,
        ticketFiles
    ]);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);

                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper className="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-2xl tw-transition-all tw-duration-300 tw-ease-gtr-smooth" sx={style}>
                    <Box
                        className="row tw-m-0 tw-flex-1 tw-overflow-y-auto tw-bg-white tw-p-4 sm:tw-p-6"
                        sx={{
                            margin: 0,
                            width: "100%",
                            flex: 1,
                            overflowY: "auto",
                            backgroundColor: "#ffff",
                            boxShadow: "none",
                            padding: { xs: 2, sm: 3 },
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                            "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#ffff", transition: "box-shadow 200ms ease, background-color 200ms ease" },
                            "& .MuiOutlinedInput-root:hover": { backgroundColor: "rgba(0, 108, 119, 0.02)" },
                            "& .MuiInputLabel-root.Mui-focused": { color: "#00B700" },
                            "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "0 0 0 3px rgba(0,183,0,0.12)" },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#00B700" },
                            "& .MuiCard-root": {
                                backgroundColor: "#f8fafc !important",
                                border: "none",
                                borderRadius: "12px !important",
                                boxShadow: "none",
                            },
                            "& .MuiCard-root img": { borderRadius: "8px !important" },
                        }}
                    >
                        {!loading ? (
                            <>
                                <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                                    <Typography variant="body1" sx={{ fontWeight: "bolder", marginBottom: "10px" }}>
                                        {getCurrentUser.configs.isManager ? "" : selectedTicket.name}
                                    </Typography>
                                </Box>

                                <Box
                                    className="col-sm-12 col-md-5"
                                    style={{ display: "flex", justifyContent: "end" }}
                                >
                                    {selectedTicket?.description && (
                                        <>
                                            {getCurrentUser.configs.isManager && (
                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 5,
                                                        width: "50%",
                                                    }}
                                                    clickable={true}
                                                    onClick={() => {
                                                        window.open(
                                                            `https://wa.me/${selectedTicket.phone}?text=Olá, ${selectedTicket.name}`
                                                        );
                                                    }}
                                                    label={"Contato"}
                                                    icon={
                                                        <WhatsApp
                                                            style={{ height: 24, width: 24, fill: "black" }}
                                                        />
                                                    }
                                                />
                                            )}

                                            {!getCurrentUser.configs.isManager && <Chip
                                                style={{
                                                    color: "black",
                                                    background: selectedTicket.activated
                                                        ? "#81c784"
                                                        : "#dc3545",
                                                    marginRight: 5,
                                                    width: "29%",
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={selectedTicket.activated ? "Ativo" : "Inativo"}
                                            />}

                                            <Chip
                                                className="crud-metadata-chip"
                                                style={{
                                                    color: "black",
                                                    marginRight: 5,
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={selectedTicket.createdAt}
                                            />

                                            {selectedTicket?.justification && (
                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 5,
                                                        width: "50%",
                                                    }}
                                                    disabled={!location?.state?.canEdit}
                                                    onClick={() => {
                                                        if (!isToastVisible) {
                                                            setIsOpenAnswer(true);
                                                        }
                                                    }}
                                                    label={"Resposta"}
                                                    icon={
                                                        <QuestionAnswerOutlined
                                                            style={{ height: 24, width: 24, fill: "black" }}
                                                        />
                                                    }
                                                />
                                            )}
                                            {selectedTicket.activated &&
                                                !getCurrentUser.configs.isManager &&
                                                !selectedTicket.resolved && (
                                                    <Chip
                                                        style={{
                                                            color: "black",
                                                            marginRight: 5,
                                                            width: "50%",
                                                        }}
                                                        disabled={!location?.state?.canEdit}
                                                        onClick={() => {
                                                            setInEdit(true);
                                                        }}
                                                        label="Editar"
                                                        icon={
                                                            <DriveFileRenameOutlineOutlined
                                                                style={{ height: 24, width: 24, fill: "black" }}
                                                            />
                                                        }
                                                    />
                                                )}
                                            <Chip
                                                style={{
                                                    color: "black",
                                                    marginRight: 5,
                                                    width: "50%",
                                                }}
                                                disabled={!location?.state?.canEdit || isImpersonationLocked()}
                                                onClick={() => {
                                                    if (!isToastVisible) {
                                                        verifyBeforeUpdateStatus(
                                                            selectedTicket.id,
                                                            selectedTicket.activated
                                                                ? "deactivate"
                                                                : "activate"
                                                        );
                                                    }
                                                }}
                                                label={
                                                    selectedTicket.activated ? "Desativar" : "Ativar"
                                                }
                                                icon={
                                                    <RemoveCircleOutlineOutlined
                                                        style={{ height: 24, width: 24, fill: "black" }}
                                                    />
                                                }
                                            />

                                            {!selectedTicket.resolved &&
                                                getCurrentUser.configs.isManager && (
                                                    <Chip
                                                        style={{
                                                            color: "black",
                                                            marginRight: 5,
                                                            width: "50%",
                                                        }}
                                                        disabled={!location?.state?.canEdit}
                                                        onClick={() => {
                                                            if (!isToastVisible) {
                                                                setIsOpenJustification(true);
                                                            }
                                                        }}
                                                        label={"Resolver"}
                                                        icon={
                                                            <BookmarkAddedOutlined
                                                                style={{ height: 24, width: 24, fill: "black" }}
                                                            />
                                                        }
                                                    />
                                                )}
                                        </>
                                    )}
                                </Box>

                                {getCurrentUser.configs.isManager && ticketLetter}

                                {currentParameters?.isViewingAll && inInsert && <>
                                    <Box className="col-md-6" style={{ marginBottom: 10 }}>
                                        <Autocomplete
                                            id="chip-label-select-secretary"
                                            className="input-select-secretary"
                                            style={{
                                                width: "100%",
                                                minHeight: "56px",
                                                height: "56px",
                                                backgroundColor: "#ffffff29",
                                                borderColor: "lightgray",
                                            }}
                                            options={secretariesList}
                                            value={secretary}
                                            onChange={(_, option) => {
                                                setSecretary(option ?? secretaryDefault);
                                                setDepartment(departmentDefault);
                                            }}
                                            disabled={(inEdit || (!inEdit && !inInsert)) as boolean}
                                            getOptionLabel={(option) => `${option.reducedName}`}
                                            noOptionsText={"Nada encontrado"}
                                            renderInput={(params) => (
                                                <>
                                                    <FormControl
                                                        className="form-group"
                                                        style={{ display: "flex" }}
                                                    >
                                                        <InputLabel
                                                            id="country-label"
                                                            required
                                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                            shrink
                                                        >
                                                            Secretaria
                                                        </InputLabel>
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Selecione uma secretaria"
                                                            autoComplete="off"
                                                            required
                                                            InputLabelProps={{ shrink: true }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                notched: true,
                                                                label: "Secretaria",
                                                                classes: {
                                                                    notchedOutline: "custom-notch",
                                                                },
                                                            }}
                                                        />
                                                    </FormControl>
                                                </>
                                            )}
                                        />
                                    </Box>

                                    <Box className="col-md-6" style={{ marginBottom: 10 }}>
                                        <Autocomplete
                                            id="chip-label-select-department"
                                            className="input-select-department"
                                            style={{
                                                width: "100%",
                                                minHeight: "56px",
                                                height: "56px",
                                                backgroundColor: "#ffffff29",
                                                borderColor: "lightgray",
                                            }}
                                            options={departmentsList}
                                            value={department}
                                            onChange={(_, option) => {
                                                setDepartment(option ?? departmentDefault);
                                            }}
                                            disabled={(inEdit || (!inEdit && !inInsert)) as boolean}
                                            getOptionLabel={(option) => `${option.reducedName}`}
                                            noOptionsText={"Nada encontrado"}
                                            renderInput={(params) => (
                                                <>
                                                    <FormControl
                                                        className="form-group"
                                                        style={{ display: "flex" }}
                                                    >
                                                        <InputLabel
                                                            id="country-label"
                                                            required
                                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                            shrink
                                                        >
                                                            Departamento
                                                        </InputLabel>
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Selecione um departamento"
                                                            autoComplete="off"
                                                            required
                                                            InputLabelProps={{ shrink: true }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                notched: true,
                                                                label: "Departamento",
                                                                classes: {
                                                                    notchedOutline: "custom-notch",
                                                                },
                                                            }}
                                                        />
                                                    </FormControl>
                                                </>
                                            )}
                                        />
                                    </Box></>}

                                {!getCurrentUser.configs.isManager && (
                                    <>
                                        <Box
                                            className="col-md-12"
                                            style={{ margin: "15px 0px 15px 0px" }}
                                        >
                                            <FormControl
                                                className="form-group"
                                                style={{ display: "flex", width: "100%" }}
                                            >
                                                <InputLabel
                                                    id="demo-multiple-password-label"
                                                    shrink
                                                    disabled={
                                                        (selectedTicket?.description &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                    style={{ fontFamily: "Prometo" }}
                                                    required
                                                >
                                                    Descrição
                                                </InputLabel>
                                                <TextField
                                                    name="name"
                                                    autoComplete="off"
                                                    multiline

                                                    rows={5}
                                                    InputProps={{
                                                        label: "descrição",
                                                        notched: true,
                                                        style: { fontFamily: "Prometo" },
                                                    }}
                                                    disabled={
                                                        (selectedTicket?.description &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                    value={ticketDescription}
                                                    onChange={(event) => {
                                                        setTicketDescription(event.target.value);
                                                    }}
                                                    type="text"
                                                    className="form-control-login"
                                                    placeholder="Digite a descrição"
                                                    required
                                                />
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    className="visibility-password"
                                                    disabled
                                                    onMouseDown={(e: SyntheticEvent) => { }}
                                                    edge="end"
                                                    size="large"
                                                >
                                                    <AbcOutlined />
                                                </IconButton>
                                            </FormControl>
                                        </Box>

                                        <Box
                                            className="col-md-6"
                                            style={{ margin: "15px 0px 20px 0px" }}
                                        >
                                            <FormControl
                                                className="form-group"
                                                style={{ display: "flex" }}
                                            >
                                                <InputLabel
                                                    id="city-label"
                                                    style={{ color: "black", fontFamily: "Prometo" }}
                                                    required
                                                    shrink
                                                    disabled={
                                                        (selectedTicket?.description &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                >
                                                    Tipo de atendimento
                                                </InputLabel>
                                                <Select
                                                    id="chip-label-select-city"
                                                    name="city"
                                                    className="form-control input-select-city"
                                                    labelId="chip-label-select-city"
                                                    label={"Tipo de atendimento"}
                                                    required
                                                    disabled={
                                                        (selectedTicket?.description &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    displayEmpty
                                                    input={
                                                        <OutlinedInput
                                                            id="select-chip-select-city"
                                                            label={"Tipo de atendimento"}
                                                            style={{ borderColor: "gray" }}
                                                            notched
                                                        />
                                                    }
                                                    renderValue={(item) => (
                                                        <Chip
                                                            key={item}
                                                            style={{
                                                                color: "black",
                                                                width: 200,
                                                                fontFamily: "Prometo",
                                                            }}
                                                            label={item || "Selecione um tipo"}
                                                        />
                                                    )}
                                                    value={ticketType}
                                                    onChange={(event: SelectChangeEvent) => {
                                                        setTicketType(event.target.value);
                                                    }}
                                                >
                                                    {ticketTypesList.map((item, i) => (
                                                        <MenuItem key={item.id + i} value={item.name}>
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                    <MenuItem key={"noselect"} value={""}>
                                                        Selecione um tipo
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>

                                        <Box
                                            className="col-md-6"
                                            style={{ margin: "15px 0px 20px 0px" }}
                                        >
                                            <FormControl
                                                className="form-group"
                                                style={{ display: "flex" }}
                                            >
                                                <InputLabel
                                                    id="city-label"
                                                    style={{ color: "black", fontFamily: "Prometo" }}
                                                    required
                                                    shrink
                                                    disabled={
                                                        (selectedTicket?.description &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                >
                                                    Gravidade
                                                </InputLabel>
                                                <Select
                                                    id="chip-label-select-city"
                                                    name="city"
                                                    className="form-control input-select-city"
                                                    required
                                                    labelId="chip-label-select-city"
                                                    label={"Gravidade"}
                                                    disabled={
                                                        (selectedTicket?.description &&
                                                            !inEdit &&
                                                            !inInsert) as boolean
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        backgroundColor: "#ffffff29",
                                                        borderColor: "lightgray",
                                                    }}
                                                    displayEmpty
                                                    input={
                                                        <OutlinedInput
                                                            id="select-chip-select-city"
                                                            label={"Gravidade"}
                                                            style={{ borderColor: "gray" }}
                                                            notched
                                                        />
                                                    }
                                                    renderValue={(item) => (
                                                        <Chip
                                                            key={item}
                                                            style={{
                                                                color: "black",
                                                                width: 200,
                                                                fontFamily: "Prometo",
                                                            }}
                                                            label={item || "Selecione uma gravidade"}
                                                        />
                                                    )}
                                                    value={ticketGravity}
                                                    onChange={(event: SelectChangeEvent) => {
                                                        setTicketGravity(event.target.value);
                                                    }}
                                                >
                                                    {ticketGravitiesList.map((item, i) => (
                                                        <MenuItem key={item.id + i} value={item.name}>
                                                            {item.name}
                                                        </MenuItem>
                                                    ))}
                                                    <MenuItem key={"noselect"} value={""}>
                                                        Selecione um gravidade
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box className="col-md-12" style={{ marginBottom: 20 }}>
                                            {selectedTicket.description && <Chip
                                                style={{
                                                    color: "black",
                                                    marginRight: 5,
                                                    background: selectedTicket.resolved ? "#81c784" : "#dc3545",
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={`Status: ${selectedTicket.resolved ? "Solucionado" : "Pendente"}`}
                                            />}

                                            {selectedTicket.resolved && <><Chip
                                                style={{
                                                    color: "black",
                                                    marginRight: 5,
                                                    background: "#81c784",
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={`Respondido em: ${selectedTicket.respondedAt}`}
                                            />

                                                <Chip
                                                    style={{
                                                        color: "black",
                                                        marginRight: 5,
                                                        fontWeight: "bolder",
                                                    }}
                                                    clickable={false}
                                                    onClick={() => { }}
                                                    label={`Respondido por: ${selectedTicket.userResponded}`}
                                                />
                                            </>}
                                        </Box>

                                        <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                                            <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                                Anexos(Opcional)
                                            </Typography>
                                        </Box>

                                        <Box className="col-md-12" style={{ marginBottom: 20 }}>
                                            <Box className="attachment-dropzone" sx={{ paddingTop: 2, display: "flex" }}>
                                                <input
                                                    type="file"
                                                    style={{ display: "none" }}
                                                    ref={fileInputRef}
                                                    accept="image/*"
                                                    onChange={(
                                                        event: React.ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        const target = event.target;
                                                        const file = target?.files;

                                                        if (
                                                            file &&
                                                            file[0].type.substring(0, 5) === "image"
                                                        ) {
                                                            setCurrentTicketFile(file);
                                                        } else {
                                                            setCurrentTicketFile(null);
                                                        }
                                                    }}
                                                />
                                                {ticketFiles && ticketFiles?.length > 0 ? (
                                                    ticketFiles?.map((item: any, index: any) => {
                                                        return (
                                                            <>
                                                                {item.type === "image" ? (
                                                                    <Card
                                                                        style={{
                                                                            background: "#f3eeeec4",
                                                                            padding: 5,
                                                                            margin: 3,
                                                                            borderRadius: 5,
                                                                        }}
                                                                    >
                                                                        <img
                                                                            key={index}
                                                                            src={item?.file}
                                                                            alt={"preview"}
                                                                            style={{
                                                                                objectFit: "cover",
                                                                                width: 150,
                                                                                height: 150,
                                                                                display: "flex",
                                                                                boxShadow: "none",
                                                                                borderRadius: 5,
                                                                                background: "gray",
                                                                                margin: 5,
                                                                            }}
                                                                        />
                                                                        <CardActions
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                            }}
                                                                        >
                                                                            <DownloadOutlined
                                                                                onClick={() => onHandleDownload(item?.file, "anexo" + (index + 1))}
                                                                                style={{
                                                                                    height: 24,
                                                                                    width: 24,
                                                                                    fill: "#00B700",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            />

                                                                            {!getCurrentUser.configs.isManager && (
                                                                                <HideImageOutlined
                                                                                    onClick={() => {
                                                                                        const newList = ticketFiles.filter(
                                                                                            (it) => it.id !== item.id
                                                                                        );
                                                                                        setTicketRemovedFiles((prev) => [
                                                                                            ...prev,
                                                                                            item.id,
                                                                                        ]);
                                                                                        setTicketFiles(newList);
                                                                                    }}
                                                                                    style={{
                                                                                        height: 24,
                                                                                        width: 24,
                                                                                        fill: "red",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                />
                                                                            )}

                                                                            <FullscreenOutlined
                                                                                onClick={() => onHandleFullScreen(item?.file, "anexo" + (index + 1))}
                                                                                style={{
                                                                                    height: 24,
                                                                                    width: 24,
                                                                                    fill: "blue",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            />
                                                                        </CardActions>
                                                                    </Card>
                                                                ) : (
                                                                    <Card
                                                                        key={index}
                                                                        style={{
                                                                            background: "#f3eeeec4",
                                                                            padding: 5,
                                                                            margin: 3,
                                                                            borderRadius: 5,
                                                                        }}
                                                                    >
                                                                        <FilePresentOutlined
                                                                            style={{
                                                                                objectFit: "cover",
                                                                                width: 150,
                                                                                height: 150,
                                                                                display: "flex",
                                                                                boxShadow: "none",
                                                                                borderRadius: 5,
                                                                                background: "transparent",
                                                                                fill: "#00b70080",
                                                                                margin: 5,
                                                                            }}
                                                                        />
                                                                        <CardActions
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                            }}
                                                                        >
                                                                            <DownloadOutlined
                                                                                onClick={() => onHandleDownload(item?.file, "anexo" + (index + 1))}
                                                                                style={{
                                                                                    height: 24,
                                                                                    width: 24,
                                                                                    fill: "#00B700",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            />

                                                                            {!getCurrentUser.configs.isManager && (
                                                                                <HideImageOutlined
                                                                                    onClick={() => {
                                                                                        const newList = ticketFiles.filter(
                                                                                            (it) => it.id !== item.id
                                                                                        );
                                                                                        setTicketRemovedFiles((prev) => [
                                                                                            ...prev,
                                                                                            item.id,
                                                                                        ]);
                                                                                        setTicketFiles(newList);
                                                                                    }}
                                                                                    style={{
                                                                                        height: 24,
                                                                                        width: 24,
                                                                                        fill: "red",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                />
                                                                            )}

                                                                            <FullscreenOutlined
                                                                                onClick={() => onHandleFullScreen(item?.file, "anexo" + (index + 1))}
                                                                                style={{
                                                                                    height: 24,
                                                                                    width: 24,
                                                                                    fill: "red",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            />
                                                                        </CardActions>
                                                                    </Card>
                                                                )}
                                                            </>
                                                        );
                                                    })
                                                ) : (
                                                    <Box style={{ display: "flex" }}>
                                                        <Chip
                                                            sx={{
                                                                color: "#00B700",
                                                                width: selectedTicket.id ? -1 : 200,
                                                                "& .MuiChip-icon": {
                                                                    marginLeft: "0px",
                                                                },
                                                            }}
                                                            disabled={!inEdit && !inInsert}
                                                            label="Anexar"
                                                            icon={
                                                                <Fab
                                                                    size="small"
                                                                    aria-label="add"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        if (fileInputRef.current) {
                                                                            fileInputRef.current.click();
                                                                        }
                                                                    }}
                                                                    disabled={
                                                                        ticketFiles.length === 3 ||
                                                                        ((selectedTicket?.name &&
                                                                            !inEdit &&
                                                                            !inInsert) as boolean)
                                                                    }
                                                                    sx={{
                                                                        marginRight: "8px",
                                                                        background: "#00B700",
                                                                        color: "#ffff",
                                                                        "& .disabled": {
                                                                            background: "gray",
                                                                        },
                                                                        "&:hover": {
                                                                            background: "#00B700",
                                                                            color: "#ffff",
                                                                        },
                                                                    }}
                                                                >
                                                                    <AddOutlined
                                                                        sx={{
                                                                            background: "#00B700",
                                                                            color: "#ffff",
                                                                            "& .disabled": {
                                                                                background: "gray",
                                                                            },
                                                                            "&:hover": {
                                                                                background: "#00B700",
                                                                                color: "#ffff",
                                                                            },
                                                                        }}
                                                                    />
                                                                </Fab>
                                                            }
                                                        />
                                                    </Box>
                                                )}

                                                {ticketFiles && ticketFiles?.length > 0 && (
                                                    <Box
                                                        className="col-md-6"
                                                        style={{ margin: "15px 0px 15px 0px" }}
                                                    >
                                                        <Fab
                                                            size="small"
                                                            aria-label="add"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (fileInputRef.current) {
                                                                    fileInputRef.current.click();
                                                                }
                                                            }}
                                                            disabled={
                                                                ticketFiles.length === 3 ||
                                                                ((selectedTicket?.name &&
                                                                    !inEdit &&
                                                                    !inInsert) as boolean)
                                                            }
                                                            sx={{
                                                                marginRight: "5px",
                                                                background: "#00B700",
                                                                color: "#ffff",
                                                                "& .disabled": {
                                                                    background: "gray",
                                                                },
                                                                "&:hover": {
                                                                    background: "#00B700",
                                                                    color: "#ffff",
                                                                },
                                                            }}
                                                        >
                                                            <AddOutlined />
                                                        </Fab>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </>
                                )}
                            </>
                        ) : (
                            loadingEsqueleton
                        )}
                    </Box>
                    <Box
                        className="tw-flex tw-w-full tw-flex-none tw-justify-end tw-border-t tw-border-black/10 tw-bg-white tw-p-4"
                        sx={{ display: "flex", width: "100%", alignSelf: "stretch", justifyContent: "flex-end", padding: 2, borderTop: "1px solid rgba(0, 0, 0, 0.10)", backgroundColor: "#ffff" }}
                    >

                        <Paper
                            className="tw-flex tw-w-full tw-flex-col-reverse tw-gap-2 sm:tw-w-auto sm:tw-flex-row"
                            elevation={0}
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column-reverse", sm: "row" },
                                justifyContent: "flex-end",
                                width: { xs: "100%", sm: "auto" },
                                marginLeft: "auto",
                                alignSelf: "flex-end",
                                gap: 1,
                                background: "transparent",
                            }}
                        >
                            <Button
                                type="button"
                                style={{
                                    fontFamily: "Prometo",
                                    color: "#ffff",
                                    marginRight: 5,
                                }}
                                onClick={() => {
                                    if (!isToastVisible) {
                                        verifyBeforeCancel(selectedTicket);
                                    }
                                }}
                                className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                            >
                                <CloseOutlined style={{ marginRight: 5 }} />
                                <Typography
                                    className="forgot-password"
                                    style={{
                                        fontFamily: "Prometo",
                                        fontSize: "16px",
                                        color: "#ffff",
                                    }}
                                >
                                    Fechar
                                </Typography>
                            </Button>
                            {!getCurrentUser.configs.isManager && (
                                <Button
                                    type="button"
                                    style={{ fontFamily: "Prometo", color: "#ffff" }}
                                    disabled={!inEdit && !inInsert}
                                    onClick={() => {
                                        inInsert && !inEdit ? onSave() : onUpdate();
                                    }}
                                    className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                >
                                    <SaveOutlined style={{ marginRight: 5 }} />
                                    <Typography
                                        className="forgot-password"
                                        style={{
                                            fontFamily: "Prometo",
                                            fontSize: "16px",
                                            color: "#ffff",
                                        }}
                                    >
                                        Salvar
                                    </Typography>
                                </Button>
                            )}
                        </Paper>
                    </Box>
                </Paper>
            </Rmodal>
        );
    }, [
        onSave,
        onUpdate,
        verifyBeforeUpdateStatus,
        verifyBeforeCancel,
        currentParameters?.isViewingAll,
        department,
        departmentsList,
        secretariesList,
        secretary,
        ticketTypesList,
        selectedTicket,
        ticketDescription,
        ticketGravity,
        ticketType,
        ticketFiles,
        getCurrentUser.configs.isManager,
        ticketLetter,
        ticketGravitiesList,
        location?.state?.canEdit,
        isToastVisible,
        validationText,
        isOpenDetails,
        loading,
        loadingEsqueleton,
        inInsert,
        inEdit,
    ]);

    return (
        <>
            {DetailsModal}
            {justificationModal}
            {justificationAnswer}
            <Toast
                ref={toastRef}
                position="center"
                onShow={() => {
                    setIsToastVisible(true);

                    if (validationText) {
                        setTimeout(() => {
                            setFieldsIsValid(true);
                            setIsToastVisible(false);
                        }, 3000);
                    }
                }}
            />
            <GridTemplate
                columns={columns}
                headerName="Atendimento"
                isHiddenMenu={false}
                isLoading={loading}
                order={"asc"}
                rows={rowsOptions(filteredList)}
                sortField="description"
                withFilter={true}
                withOptions={true}
                query={query}
                setQuery={(value: string) => setQuery(value)}
                filterPlaceholder={"Cliente, departamento, tipo ou gravidade"}
                onRefresh={handleGetAllTickets}
                onExport={getReport}
                disableAddButton={
                    !location?.state?.canCreate || getCurrentUser.configs.isManager
                }
                handleNext={(activated: string, page: number, size: number) => handleGetAllTickets(activated, page, size)}
                handlePrevious={() => { }}
                isLastPage={isLastPage}
                totalPerPage={numberOfElementsPerPage}
                currentPage={pageNumber}
                totalElements={numberOfElements}
                contentHeight={"500px"}
                containerHeight="auto"
                style={{ width: "100%", marginTop: 0, padding: 0 }}
                onAdd={() => {
                    setIsOpenDetails(true);
                    setInInsert(true);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                onClickRow={(item: any) => {
                    setIsOpenDetails(true);
                    setSelectedTicked(item);
                    handleOnEditValues(item);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
            />
        </>
    );
};

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: { xs: "calc(100vw - 24px)", sm: "min(94vw, 1100px)" },
    maxWidth: 1100,
    maxHeight: "calc(100dvh - 24px)",
    overflow: "hidden",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: 0,
    fontFamily: "Prometo",
};

export default CustomerHelpDeskComponent;
